import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  h2 {
    text-align: center;
  }
`;

const ChildWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 3rem;
  margin-top: 2rem;
  width: 100%;

  > * {
    flex: 0 1
      calc(
        (
            80% -
              (${({ $numberOfColumns }) => ($numberOfColumns || 3) - 1} * 3rem)
          ) /
          ${({ $numberOfColumns }) => $numberOfColumns || 3}
      );
    max-width: calc(
      (
          80% -
            (${({ $numberOfColumns }) => ($numberOfColumns || 3) - 1} * 3rem)
        ) /
        ${({ $numberOfColumns }) => $numberOfColumns || 3}
    );
  }

  @media (max-width: 768px) {
    > * {
      flex-basis: calc((100% - 2rem) / 2);
      max-width: calc((100% - 2rem) / 2);
    }
  }

  @media (max-width: 480px) {
    > * {
      flex-basis: 100%;
    }
  }
`;

export default function BrandLogo({ children, numberOfColumns, title }) {
  return (
    <Wrapper>
      <h2>{title}</h2>
      <ChildWrapper $numberOfColumns={numberOfColumns}>{children}</ChildWrapper>
    </Wrapper>
  );
}

BrandLogo.propTypes = {
  children: PropTypes.node,
  numberOfColumns: PropTypes.number,
  title: PropTypes.string,
};
